function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#F1F1F1",
  points: "291.406,0 309.723,68.361 313.586,67.326 295.547,0 "
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#6A3788",
  points: "271.213,0 230.166,11 249.836,84.41 309.723,68.361 291.406,0 "
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 239.866,
  y: 8.684,
  transform: "matrix(0.9659 -0.259 0.259 0.9659 -3.7718 64.7368)",
  fill: "#391D41",
  width: 7.888,
  height: 76
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 248.547,
  y: 15.416,
  transform: "matrix(0.9659 -0.2588 0.2588 0.9659 4.4221 70.0541)",
  fill: "#FFFFFF",
  width: 39.437,
  height: 5.633
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#6A3788",
  d: "M245.801,47.582c0.241,0.898-0.295,1.825-1.197,2.066c-0.901,0.242-1.828-0.293-2.068-1.192 c-0.242-0.903,0.292-1.829,1.193-2.071C244.631,46.145,245.559,46.678,245.801,47.582z"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#6A3788",
  d: "M239.967,25.811c0.243,0.904-0.292,1.832-1.193,2.073c-0.902,0.241-1.83-0.293-2.072-1.197 c-0.24-0.899,0.295-1.827,1.197-2.068C238.8,24.377,239.727,24.912,239.967,25.811z"
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  fill: "#6A3788",
  cx: 250,
  cy: 69.785,
  r: 1.69
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "122.518,6.768 81.172,21.816 107.166,93.233 163.547,72.712 143.025,16.331 "
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#DADADA",
  points: "127.99,21.803 143.025,16.331 122.518,6.768 "
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#B5B5B5",
  d: "M138.254,47.919c-1.6-0.191-4.012,0.305-7.188,1.429l-7.717-6.187c0.545-1.962,1.436-5.769,0.605-8.047 c-0.852-2.338-3.537-4.165-6.854-2.958c-3.33,1.212-4.154,4.356-3.256,6.83c0.787,2.158,3.59,4.45,5.158,5.605l-1.975,9.865 c-3.145,1.176-5.313,2.347-6.418,3.523c-1.98,2.091-1.803,5.354,0.365,7.42c1.453,1.372,3.404,1.79,5.24,1.122l0,0 c0.834-0.305,1.598-0.814,2.102-1.447c1.504-1.79,2.16-5.606,2.398-7.692l9.408-3.425c1.543,1.438,4.469,3.951,6.775,4.354 c0.803,0.157,1.734,0.05,2.561-0.251c1.824-0.664,3.039-2.234,3.268-4.219C143.078,50.861,141.105,48.251,138.254,47.919z  M115.246,62.467c-0.053,0.04-0.193,0.149-0.422,0.232c-0.404,0.147-0.707,0.089-1.051-0.243c-0.563-0.531-0.639-1.229-0.191-1.704 c0.324-0.367,1.23-0.95,2.775-1.636C116.047,60.646,115.654,61.981,115.246,62.467z M118.484,35.954 c1.172-0.426,1.555,0.235,1.668,0.545c0.223,0.616,0.068,2.078-0.234,3.643c-1.121-0.954-2.047-1.947-2.264-2.541 C117.223,36.413,118.17,36.069,118.484,35.954z M121.484,52.787l1.033-5.103l4.072,3.244L121.484,52.787z M138.713,53.38 c-0.057,0.477-0.244,0.713-0.645,0.858c-0.225,0.082-0.424,0.097-0.469,0.081c-0.629-0.097-1.799-0.865-3.016-1.837 c1.625-0.468,2.697-0.606,3.182-0.532C138.424,52.024,138.805,52.609,138.713,53.38z"
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#4E2627",
  points: "76.528,100 88.166,34 81.271,32.784 69.42,100 "
});

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#9B4B4E",
  points: "69.42,100 81.271,32.784 14.305,20.976 0.414,99.761 1.771,100 "
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "73.482,100 84.864,35.448 80.925,34.754 69.42,100 "
});

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFDBDC",
  d: "M54.99,44.135c-0.057-0.461-0.434-0.859-0.863-0.935c-0.429-0.075-7.898-1.393-7.898-1.393l0.68-3.861 c0.102-0.576-0.285-1.117-0.856-1.218c-0.577-0.102-1.12,0.274-1.222,0.851l-0.68,3.861l-7.9-1.393 c-0.43-0.075-0.92,0.169-1.131,0.583s-5.882,12.36-5.885,12.376c-0.447,2.536,1.248,4.948,3.779,5.395s4.947-1.241,5.395-3.777 c0.002-0.016-1.156-12.262-1.156-12.262l6.532,1.151l-3.614,20.5l-5.652-0.996c-0.572-0.102-1.117,0.286-1.218,0.859 c-0.101,0.57,0.28,1.115,0.853,1.216l13.375,2.358c0.574,0.102,1.122-0.279,1.223-0.85c0.102-0.573-0.282-1.124-0.857-1.226 l-5.645-0.995l3.614-20.5l6.53,1.151c0,0-5.275,11.111-5.278,11.127c-0.447,2.536,1.245,4.948,3.776,5.395s4.949-1.241,5.396-3.777 C56.29,57.761,55.047,44.596,54.99,44.135z M36.193,53.163l-4.369-0.771l3.561-7.443L36.193,53.163z M49.694,55.544l3.569-7.442 l0.801,8.213L49.694,55.544z"
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#75383B",
  points: "8.494,100 22.184,22.365 14.305,20.976 0.414,99.761 1.77,100 "
});

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#494949",
  d: "M227.166,40c0-2.2-1.801-4-4-4h-62c-2.201,0-4,1.8-4,4v36c0,2.2,1.799,4,4,4h62c2.199,0,4-1.8,4-4V40z"
});

var _ref18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 162.166,
  y: 40,
  fill: "#FFFFFF",
  width: 56,
  height: 36
});

var _ref19 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#919191",
  d: "M224.666,54c0-1.104-0.896-2-2-2c-1.105,0-2,0.896-2,2c0,0.842,0,7.158,0,8c0,1.104,0.895,2,2,2 c1.104,0,2-0.896,2-2C224.666,61.13,224.666,54.87,224.666,54z"
});

var _ref20 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#E80081",
  d: "M185.1,50.935c1.956-1.956,4.312-2.935,7.066-2.935c2.754,0,5.109,0.979,7.065,2.935 s2.935,4.312,2.935,7.065c0,2.755-0.979,5.11-2.935,7.065C197.275,67.022,194.92,68,192.166,68c-2.755,0-5.11-0.978-7.066-2.935 c-1.956-1.955-2.934-4.311-2.934-7.065C182.166,55.246,183.144,52.891,185.1,50.935z M186.508,63.657 c1.581,1.581,3.467,2.371,5.658,2.371c2.189,0,4.076-0.79,5.657-2.371c1.58-1.58,2.371-3.466,2.371-5.657 c0-2.19-0.791-4.076-2.371-5.657c-1.581-1.58-3.468-2.371-5.657-2.371c-2.191,0-4.077,0.791-5.658,2.371 c-1.58,1.581-2.371,3.467-2.371,5.657C184.137,60.191,184.928,62.077,186.508,63.657z M190.146,62.507v-9.014l6.01,4.507 L190.146,62.507z"
});

var _ref21 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#E76DB6",
  d: "M249.438,38.919l4.438,1.19l0.595-2.22c0.327-1.22-0.398-2.484-1.625-2.811 c-1.227-0.329-2.485,0.403-2.813,1.622L249.438,38.919z"
});

var _ref22 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#F9B233",
  points: "249.438,38.919 253.875,40.109 244.604,74.713 240.166,73.528 "
});

var _ref23 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 248.884,
  y: 39.45,
  transform: "matrix(0.966 0.2585 -0.2585 0.966 19.2056 -63.5165)",
  fill: "#929292",
  width: 4.595,
  height: 3.676
});

var _ref24 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#3B3835",
  points: "241.074,79 242.678,77.053 240.662,76.512 "
});

var _ref25 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#FFBC80",
  points: "240.166,73.528 240.662,76.512 242.678,77.053 244.604,74.713 "
});

var SvgMatCapa = function SvgMatCapa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "314px",
    height: "100px",
    viewBox: "0 0 314 100",
    enableBackground: "new 0 0 314 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMatCapa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/matCapa.275dd05c.svg";
export { ForwardRef as ReactComponent };